import React from 'react'
import styles from './index.module.scss'
import cn from 'classnames'
import PropTypes from 'prop-types'
import { INVOICE_STATUSES } from '../../../utilities/constants'
import { stringToEnum } from '../../../utilities/stringUtilities'
import { formatToUSD } from '../../../utilities/formatters'

export default function InvoiceSummary ({
  summaryData,
  onSubmit,
  activeStatus
}) {
  const getStyles = (status) => {
    const tempStyles = []
    status === activeStatus && tempStyles.push(styles.activeStatus)
    switch (status) {
      case INVOICE_STATUSES.OPEN:
        tempStyles.push(styles.open)
        break
      case INVOICE_STATUSES.OVERDUE:
        tempStyles.push(styles.overdue)
        break
      case INVOICE_STATUSES.CLOSED_IN_QBO:
        tempStyles.push(styles.closed)
        break
      case INVOICE_STATUSES.PAID:
        tempStyles.push(styles.paid)
        break
      default:
        tempStyles.push(styles.defaultOption)
    }
    return tempStyles
  }

  const getAmount = (amount) => {
    const temp = parseFloat(amount) ?? 0
    return temp > 0 ? `$${formatToUSD(parseFloat(temp))}` : '--'
  }

  return (
    <div className={styles.summaryContainer}>
      <div className={styles.title}>Summary</div>
      <div className={styles.tileContainer}>
        {summaryData.map((item, index) => {
          const status = stringToEnum(item.status)
          const style = getStyles(status)
          return (
            <button
              className={cn(styles.tile, ...style)}
              key={status}
              onClick={() => onSubmit({ status })}>
              <div className={styles.amount}>
                {getAmount(item.amount)}
              </div>
              <div>
                {item.status}
              </div>
            </button>
          )
        })}
      </div>
    </div>
  )
}

InvoiceSummary.propTypes = {
  summaryData: PropTypes.array,
  onSubmit: PropTypes.func.isRequired,
  activeStatus: PropTypes.string
}
